import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const ProductDescriptionDefaultProps = {
  ...ClassNameDefaultProps,
  brand: null,
  codeOldCompanySku: null,
  discountClasses: [],
  manufacturerSku: null,
  sku: null,
  complementaryDescription: '',
  lengthName: null,
  name: '',
  range: null,
};

export const ProductDescriptionPropTypes = {
  ...ClassNamePropTypes,
  brand: PropTypes.shape({
    logo: PropTypes.shape({}),
    name: PropTypes.string,
  }),
  className: PropTypes.string,
  codeOldCompanySku: PropTypes.string,
  discountClasses: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  ),
  manufacturerSku: PropTypes.string,
  sku: PropTypes.string,
  complementaryDescription: PropTypes.string,
  lengthName: PropTypes.bool,
  name: PropTypes.string,
  range: PropTypes.string,
};
